import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=72e9e224&scoped=true&"
import script from "./PerPage.vue?vue&type=script&lang=js&"
export * from "./PerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9e224",
  null
  
)

export default component.exports